import { useQuery } from "@tanstack/react-query"
import { carrotClient } from "#/utils/CarrotClient"
import { reportError } from "#/utils/ErrorReporting"
import buildCarrotApiRetryPolicy from "#/utils/CarrotApiRetryPolicy"
import { RegisteringUser } from "#/lib/carrot-api/types/RegisteringUser"

const registeringUserQueryKey = "getRegisteringUser"

export function useFetchRegisteringUser(guid: string, setRegisteringUser: (user: RegisteringUser) => void) {
  return useQuery(
    [registeringUserQueryKey, guid],
    async () => {
      await carrotClient.logout()
      return carrotClient.getRegisteringUser(guid)
    },
    {
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      refetchOnReconnect: false,
      retry: buildCarrotApiRetryPolicy(3),
      onSuccess: setRegisteringUser,
      onError: (error) => reportError(error)
    }
  )
}
